// ============================================================
// ByOurConsent.com -- Shared Word/RTF export for premium tools
//
// Every premium tool previously had its own hand-written RTF
// template for the "Download Word" button. Each one independently
// had a mismatched brace count (RTF's { } group delimiters must
// balance exactly), which corrupted every downloaded file
// regardless of content. One shared, carefully verified function
// instead of nine separate copies.
// ============================================================

// RTF control characters (\, {, }) must be escaped first. Any
// character outside the basic ASCII range (em dashes, curly quotes,
// etc. -- common in AI-generated text) then needs RTF's \uNNNN?
// unicode escape, since the \ansi charset can't represent them
// directly and left as-is can render as garbage or break parsing.
const escapeRtf = (text) => text
    .replace(/[\\{}]/g, '\\$&')
    .replace(/[\u0080-\uFFFF]/g, ch => `\\u${ch.charCodeAt(0)}?`);

// content: the report text, with "## Heading" lines rendered bold.
// filename: without extension -- .rtf is added automatically.
export const downloadReportAsWord = (content, filename) => {
    const bodyLines = content.split('\n').map(line => {
        return line.startsWith('## ')
            ? `\\b ${escapeRtf(line.replace('## ', ''))}\\b0\\par`
            : `${escapeRtf(line)}\\par`;
    }).join('\n');

    // Every { has exactly one matching } -- kept deliberately flat
    // and simple to keep that easy to verify at a glance:
    //   doc{ fonttbl{ font{ } } body \par lines }
    const rtfContent = `{\\rtf1\\ansi\\ansicpg1252\\deff0{\\fonttbl{\\f0\\fnil\\fcharset0 Arial;}}\n\\f0\\fs24\n${bodyLines}\n}`;

    const blob = new Blob([rtfContent], { type: 'application/rtf' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = filename.endsWith('.rtf') ? filename : `${filename}.rtf`;
    a.click();
    URL.revokeObjectURL(url);
};
